<template>
  <account-template
    icon="icons/google-my-business-logo"
    :account="businessProfile"
    account-name="Business Profile"
    connection-href="/google/connect/business/onboarding"
    :connected-data="connectedData"
  />
</template>

<script>
import {mapGetters} from "vuex";
import AccountTemplate from "./AccountTemplate";

export default {
  components: {
    AccountTemplate,
  },
  computed: {
    ...mapGetters('onboarding', [
      'businessProfile',
    ]),
    connectedData() {
      if (!this.businessProfile) {
        return null;
      }
      return [
        {
          'title': 'Title',
          'value': this.businessProfile.title ?? null,
        },
        {
          'title': 'Address',
          'value': this.businessProfile.short_address ?? null,
        },
      ]
    }
  }
}
</script>

